<template>
    <div class="grid__col" :class="[spanClass]" :style="[margins, paddings]">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Column',

    props: {
        span: {
            // @TODO responsive object notation
            type: [Number, String],
            default: 0
        }
    },

    inject: ['context'],

    computed: {
        margins() {
            const { gap, gapY } = this.context;

            return { margin: `${Number(gapY) || Number(gap)}px 0` };
        },
        paddings() {
            const { gap, gapX } = this.context;

            return { padding: `0 ${Number(gapX) / 2 || Number(gap) / 2}px` };
        },
        spanClass() {
            if (!this.span) return '';

            return `grid__col--${this.span}`;
        }
    }
};
</script>
